import styled from 'styled-components'

const Line = styled.div`
  border-bottom: 1px solid #cccccc;
  margin-bottom: 16px;
`

export default Line
